"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configService = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
function setConfig(conf) {
    ui_tools_1.configService.setConfig(conf);
}
function getConfig() {
    return ui_tools_1.configService.getConfig();
}
var configService = {
    setConfig: setConfig,
    getConfig: getConfig,
};
exports.configService = configService;
